import React from "react";

export default function ProfileSkeleton() {
  return (
    <div className="min-h-screen bg-[#f8f9ff] antialiased pb-24 animate-pulse">
      <main className="max-w-xl mx-auto px-4 pt-6 space-y-6">
        <div className="space-y-2.5">
          <div className="flex items-center gap-2 pl-1">
            <div className="w-4 h-4 bg-gray-200 rounded"></div>
            <div className="h-3 bg-gray-200 rounded w-24"></div>
          </div>
          <div className="bg-white rounded-2xl p-5 border border-gray-100 space-y-5 h-[230px] flex flex-col justify-center">
            {[1, 2, 3].map((i) => (
              <div key={i} className="space-y-1.5">
                <div className="h-3 bg-gray-200 rounded w-24"></div>
                <div className="h-10 bg-gray-100 rounded-xl w-full"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-2.5">
          <div className="flex items-center gap-2 pl-1">
            <div className="w-4 h-4 bg-gray-200 rounded"></div>
            <div className="h-3 bg-gray-200 rounded w-28"></div>
          </div>
          <div className="bg-white rounded-2xl p-5 border border-gray-100 h-[138px] flex items-center">
            <div className="grid grid-cols-2 gap-y-4 gap-x-2 w-full">
              <div className="space-y-1.5">
                <div className="h-3 bg-gray-200 rounded w-16"></div>
                <div className="h-4 bg-gray-200 rounded w-32"></div>
              </div>
              <div className="space-y-1.5 flex flex-col items-end">
                <div className="h-3 bg-gray-200 rounded w-16"></div>
                <div className="h-4 bg-gray-200 rounded w-12"></div>
              </div>
              <div className="space-y-1.5">
                <div className="h-3 bg-gray-200 rounded w-12"></div>
                <div className="h-4 bg-gray-200 rounded w-40"></div>
              </div>
              <div className="space-y-1.5 flex flex-col items-end">
                <div className="h-3 bg-gray-200 rounded w-20"></div>
                <div className="h-4 bg-gray-200 rounded w-16"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-2.5">
          <div className="flex items-center gap-2 pl-1">
            <div className="w-4 h-4 bg-gray-200 rounded"></div>
            <div className="h-3 bg-gray-200 rounded w-32"></div>
          </div>
          <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-100 overflow-hidden">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="p-4 flex items-center justify-between h-[73px]"
              >
                <div className="flex items-center gap-3 flex-1">
                  <div className="w-5 h-5 bg-gray-200 rounded-full flex-shrink-0"></div>
                  <div className="space-y-1.5 flex-1">
                    <div className="h-4 bg-gray-200 rounded w-28"></div>
                    <div className="h-3 bg-gray-200 rounded w-3/4"></div>
                  </div>
                </div>
                <div className="w-10 h-6 bg-gray-200 rounded-full flex-shrink-0"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="h-[52px] bg-gray-200 rounded-xl w-full mt-8"></div>
      </main>
    </div>
  );
}
